import styles from './Table.module.css'

import React, { useState } from 'react'

import {
  flexRender,
  getCoreRowModel,
  getFilteredRowModel,
  getSortedRowModel,
  useReactTable,
} from '@tanstack/react-table'

import { FaSortUp, FaSortDown, FaSort } from 'react-icons/fa';

import { IconButton, ClickAwayListener, LinearProgress } from '@mui/material/';

import { RiFilter2Line } from "react-icons/ri";

import { default as SkeletonTable } from "../SkeletonTable/index";
import { DefaultColumnFilter, SelectColumnFilter } from './TableFilters';


function Table({ data, isLoading, columnsDefinition, skeletonRows, isFetching }) {

  if (isLoading) return (
      <SkeletonTable columns={columnsDefinition} rows={skeletonRows} />
  )

  return <RenderTable data={data} columns={columnsDefinition} isFetching={isFetching} />
}


function RenderTable({ data, columns, isFetching }) {

  const [columnFilters, setColumnFilters] = useState([])
  const [sorting, setSorting] = useState([])

  const table = useReactTable({
    data,
    columns,
    filterFns: {},
    state: {
      columnFilters,
      sorting,
    },
    onColumnFiltersChange: setColumnFilters,
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(), //client side filtering
    getSortedRowModel: getSortedRowModel(),
    onSortingChange: setSorting,
  })



  return (
    <div className={styles.tableFixHead}>
      <table>
        <thead>
          {table.getHeaderGroups().map(headerGroup => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map(header => (
                <th key={header.id} colSpan={header.colSpan} >
                  <div className={styles.thDiv} onClick={header.column.getToggleSortingHandler()}>
                    {flexRender(
                      header.column.columnDef.header,
                      header.getContext()
                    )}
                    <span className={styles.sortSpan}>
                      {header.column.getCanFilter()
                        ? <Filter column={header.column} table={table} />
                        : {
                          asc: <FaSortUp color='var(--table-th-filter-active)' />,
                          desc: <FaSortDown color='var(--table-th-filter-active)' />,
                        }[header.column.getIsSorted()] || (header.column.getCanSort() && < FaSort />)
                      }
                    </span>
                  </div>
                </th>
              )
              )}
            </tr>
          ))}
          {isFetching ? <LinearProgress sx={{ position: "absolute", bottom: "0", left: "0", width: "100%" }} data-testid='fetching-indicator'/> : null}
        </thead>
        <tbody>
          {table.getRowModel().rows.map(row => {
            return (
              <tr key={row.id}>
                {row.getVisibleCells().map(cell => {
                  return (
                    <td key={cell.id} style={{ width: cell.column.columnDef.width }}>
                      {flexRender(
                        cell.column.columnDef.cell,
                        cell.getContext()
                      )}
                    </td>
                  )
                })}
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}

function Filter({ column, table }) {
  const columnFilterValue = column.getFilterValue();
  const { filterVariant } = column.columnDef.meta || {};

  const [isOpen, setIsOpen] = useState(false);
  const [isFiltered, setIsFiltered] = useState(false);

  return (
    <>
      <span className={styles.filterOpener}>
        <IconButton
          onClick={() => {
            setIsOpen(!isOpen);
          }}
        >
          {isFiltered ? (
            <RiFilter2Line style={{ color: "var(--table-th-filter-active)" }} />
          ) : (
            <RiFilter2Line />
          )}
        </IconButton>
      </span>
      {isOpen ? (
        <ClickAwayListener onClickAway={() => { setIsOpen(false); }}>
          <div className={styles.filterContainer}>
            {filterVariant === 'select'
              ? <SelectColumnFilter
                columnFilterValue={columnFilterValue}
                setIsFiltered={setIsFiltered}
                column={column}
                table={table}
              />
              : <DefaultColumnFilter
                columnFilterValue={columnFilterValue}
                setIsFiltered={setIsFiltered}
                column={column}
              />
            }
          </div>
        </ClickAwayListener>
      ) : null}

    </>
  )
}

export default Table;